import * as errorTypes from '../types/Error';
import * as modalTypes from '../types/Modal';
import * as pageTypes from '../types/Page';
import {INITIAL_STATE} from './state/Error';


export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case errorTypes.THROW_ERROR:
            return {
                ...state,
                title: action.error.title,
                message: action.error.message,
                hasError: true
            };
        case modalTypes.SHOW_MODAL:
        case modalTypes.HIDE_MODAL:
        case errorTypes.CLEAR_ERROR:
            return {
                ...state,
                title: '',
                message: '',
                hasError: false
            };
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return INITIAL_STATE;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Error.js